import React, { useState } from 'react';
import Button from '../elements/button';
import { Upload } from '../../assets/icons';

export const UploadModal = ({ onUpload, onClose }) => {
    const [files, setFiles] = useState([]);
    const [description, setDescription] = useState('');

    return (
        <div className="modal-overlay">
            <div className="modal-content upload-form">
                <h2>Upload Files</h2>
                
                <div className="upload-area">
                    <input
                        type="file"
                        multiple
                        onChange={(e) => setFiles(Array.from(e.target.files))}
                    />
                    <div className="upload-placeholder">
                        <img src={Upload} alt="" />
                        <p>Drag files here or click to browse</p>
                    </div>
                </div>
                
                {files.length > 0 && (
                    <div className="selected-files">
                        {files.map((file, index) => (
                            <div key={index} className="file-item">
                                <span>{file.name}</span>
                                <button onClick={() => {
                                    setFiles(files.filter((_, i) => i !== index));
                                }}>×</button>
                            </div>
                        ))}
                    </div>
                )}
                
                <textarea
                    placeholder="Add a description..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                
                <div className="modal-actions">
                    <Button
                        text="Cancel"
                        variant="outline"
                        onClick={onClose}
                    />
                    <Button
                        text="Upload Files"
                        variant="primary"
                        onClick={() => onUpload(files, description)}
                        disabled={files.length === 0}
                    />
                </div>
            </div>
        </div>
    );
};